import { authenticatedGet } from "../../api/authenticatedFetch";

// listCommitments fetches active GCP committed-use discount exposure rows
// (Board Report v2 SP3; GET /api/v1/commitments). The response is wrapped under the
// "commitments" envelope key (see backend_go's writeJSON); unwrap here so callers just
// get an array, defaulting to [] when the envelope is missing or empty.
export const listCommitments = async () => {
  const data = await authenticatedGet("/api/v1/commitments");
  return data.commitments || [];
};
